import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Timeline } from './components/Timeline';
import { Comparison } from './components/Comparison';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-charcoal text-ivory selection:bg-teal selection:text-ivory" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Timeline data-id="element-4" />
        <Comparison data-id="element-5" />
        <Testimonials data-id="element-6" />
        <FAQ data-id="element-7" />
        <FinalCTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}